import { DataService } from "../service";
import { UrlConstants } from "../service/serviceConstant";


export class AuthService {
  public static async createSSOToken(data: any, headers:any) {
    return DataService.withoutAuthHeaders<any>(UrlConstants.URLNEW('urauth/v1/token/create_jwt'),
      "post", data,headers).then((data:any) => {
      return data;
    });
  }
 
  public static async getCurrentUser(){
    return DataService.get<any>(UrlConstants.URLNEW('urchat/v2/user/get_data')).then((data) => {
      return data;
    });
  }
  public static async forgotPassword(resp:any){
    return DataService.withoutAuth<any>(UrlConstants.URL('urchat/v2/user/forgot_password'), "post", resp).then((data) => {
      return data;
    });
  }
}